import { client } from '../api/apolloClient';
import { OrderGroupStoreFactory } from '@izi-logistics/common/lib/stores';

export const OrderGroupStore = OrderGroupStoreFactory({ client });
